import getAllFeatureFlags from '../../../../../utilities/getAllFeatureFlags';

const FOG_TAG_LENGTH = 6;
const DEFAULT_TAG_LENGTH = 8;

/**
 * Left pad a mark text with 0s up to the tag length this tenant uses.
 * FOG tags are 6 characters, every other FLAIR/PALM tenant uses 8.
 * Returns the value unchanged when there is nothing to pad.
 * @param {string} [markText]
 * @param {object} context
 * @returns {string|undefined}
 */
export default function padMarkText(markText, context) {
    const tagLength = getAllFeatureFlags(context).includes('forFOG') ? FOG_TAG_LENGTH : DEFAULT_TAG_LENGTH;
    if (markText == null || markText.length >= tagLength) return markText;
    return markText.padStart(tagLength, '0');
}
